// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607150313/js/" + chunkId + "." + {"44":"63a4855b","225":"293b69cf","481":"c2301797","486":"2c723057","770":"988cb039"}[chunkId] + ".0.9276476924841647.chunk.js";
};